import { FC } from "react";
import DebtReceiptWebLayout from "./WebLayout";

const DebtReceipt: FC = () => {
  return (
    <div>
      <DebtReceiptWebLayout />
    </div>
  );
};

export default DebtReceipt;
